import React, { FC, ReactElement } from 'react';
import {columns} from "./MissedOrdersDataTableCard";
import {StudentExerciseAttemptReportDataTableCard} from "../Generic/StudentExerciseAttemptReportDataTableCard";
import {useLabels} from "../../../../hooks/Labels";
import {FeedbackRowProps} from "../../ActivityFeedbackRows/types";

export const UnnecessaryOrdersDataTableCard: FC<FeedbackRowProps> = ({attemptId, activityId}): ReactElement => {
    const {t} = useLabels();
    return (
        <StudentExerciseAttemptReportDataTableCard
            title={t('unnecessary_orders_title')}
            columns={attemptId ? columns.filter(column => column.key !== 'frequency') : columns}
            query='/reports/investigation/unnecessary-order-items/'
            attemptId={attemptId}
            activityId={activityId}
        />
    )
};
